import { LOGOUT } from '~/reducers/auth/types';
import log from '~/utilities/log';
import {
  clearCookie,
  clearSession,
  getCookie,
  getObject,
  getSessionObject,
  removeObject,
  setCookie,
  setSessionObject,
} from '~/utilities/storage';

import mediator from './mediator';
import { store } from './store';

export const persistAuthSession = (session: AuthSession): void => {
  try {
    setSessionObject('authSession', session);
    setCookie('authSession', session, session.expires);

    // remove old session from localStorage
    const storedSession = getObject<AuthSession>('authSession');

    if (storedSession) {
      removeObject('authSession');
    }
  } catch (err) {
    log.error(err);
  }
};

export const getAuthSession = (): AuthSession | null => {
  try {
    // Try to get our token from session storage first or fallback to cookies
    return (
      getSessionObject<AuthSession>('authSession') ??
      getCookie<AuthSession>('authSession')
    );
  } catch {
    return null;
  }
};

export const logout = () => {
  removeAuthSession();
  mediator.publish('router:navigate', '/login');
};

export const removeAuthSession = () => {
  clearSession();
  clearCookie('authSession');
  store.dispatch({ type: LOGOUT });
};
